import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00f9a0a1&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=00f9a0a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9a0a1",
  null
  
)

export default component.exports